import {useState} from "react";
import Popup from "../../../../../components/general/popup/Popup";
import Dialog from "../../../general/dialog/Dialog";
import useValueChangeListener from "../../../../services/state/general/useValueChangeListener";
import DialogTitle from "../../../general/dialog/DialogTitle";
import DialogMessage from "../../../general/dialog/DialogMessage";
import DialogButtonContainer from "../../../general/dialog/DialogButtonContainer";
import DialogButton, {DIALOG_BUTTON_TYPE} from "../../../general/dialog/DialogButton";
import useCheckoutStore from "../../../../cart/store/checkoutStore";

const CartCheckoutError = () => {

    const [error, setError] = useState(null);

    const cartError = useCheckoutStore(state => state.error?.cart);
    useValueChangeListener(() => setError(cartError), [cartError]);

    const completeError = useCheckoutStore(state => state.error?.complete)
    useValueChangeListener(() => setError(completeError), [completeError]);

    if(!error) return;

    const title = 'Error'
    const message = (typeof error === 'string' ? error : error?.message) ?? 'Somethings gone wrong';

    return (
        <Popup>
            <Dialog>
                <DialogTitle>{title}</DialogTitle>
                <DialogMessage>{message}</DialogMessage>
                <DialogButtonContainer>
                    <DialogButton
                        onClick={() => setError(null)}
                        type={DIALOG_BUTTON_TYPE.positive}
                    >
                        OK
                    </DialogButton>
                </DialogButtonContainer>
            </Dialog>
        </Popup>
    )


}

export default CartCheckoutError;
